import { createReducer } from '@reduxjs/toolkit'
import {
  setIntroVideoDetail,
  setIsSampleUser,
  setOpenModalOutOfCredits,
  setOpenModalTryPremium,
  setUser,
  setUserIsPremium,
  setUserIsSuper,
} from './actions'
import { UserInfoStorage } from '@/utils/userInfoStorage'
import type { PremiumPromptContinuation } from './actions'

export interface UserState {
  user: any
  userIsPremium: boolean
  userIsSuper: boolean
  openModalTryPremium: {
    isOpen: boolean
    source: string | null
    callback?: Function
    opened?: boolean
    video?: string
    placeholderImage?: string
    continuation?: PremiumPromptContinuation
  }
  introVideoDetail?: {
    isOpen: boolean
    title: string
    subtitle: string
    videoSrc: string
    poster?: string
    onClickButton: Function
    contentBtn?: string
  }
  isSampleUser: Boolean
  recentDesigns: any
  openModalOutOfCredits: {
    isOpen: boolean
    callback?: Function | null
    upgradeInitiated?: boolean
  }
}

const initialUser = UserInfoStorage.get()

const initialState: UserState = {
  user: initialUser,
  userIsPremium: Boolean(initialUser?.userIsPremium) || Boolean(initialUser?.userIsSuper),
  userIsSuper: Boolean(initialUser?.userIsSuper),
  openModalTryPremium: {
    isOpen: false,
    source: null,
    callback: null,
    opened: false
  },
  introVideoDetail: null,
  isSampleUser: false,
  recentDesigns: [],
  openModalOutOfCredits: {
    isOpen: false,
    callback: null,
    upgradeInitiated: false,
  }
}

export const userReducer = createReducer(initialState, builder => {
  builder.addCase(setUser, (state, { payload }) => {
    state.user = payload
    if (!payload) {
      state.userIsPremium = false
      state.userIsSuper = false
    } else {
      state.userIsSuper = Boolean(payload.userIsSuper)
      state.userIsPremium = Boolean(payload.userIsPremium) || state.userIsSuper
    }
  })
  builder.addCase(setUserIsPremium, (state, { payload }) => {
    state.userIsPremium = payload || state.userIsSuper
  })
  builder.addCase(setUserIsSuper, (state, { payload }) => {
    state.userIsSuper = payload
    if (payload) {
      state.userIsPremium = true
    }
  })
  builder.addCase(setOpenModalTryPremium, (state, { payload }) => {
    // console.log('setOpenModalTryPremium', payload);
    
    state.openModalTryPremium = payload
  })
  builder.addCase(setIntroVideoDetail, (state, { payload }) => {
    state.introVideoDetail = payload
  })
  builder.addCase(setIsSampleUser, (state, { payload }) => {
    state.isSampleUser = payload
  })
  builder.addCase(setOpenModalOutOfCredits, (state, { payload }) => {
    state.openModalOutOfCredits = payload
  })
})
